

































































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';

@Component({
    computed: {
        ...mapGetters({
            educationalTags: 'Tags/getEducationalTags',
        }),
    },
})
export default class TenantProfilingPanel extends Mixins(InputFieldMethods, NotifyMethods) {
    public socialTagsSearch: any = '';
    public educationalTagsSearch: any = '';

    constructor() {
        super();
    }

    get currentTenant() {
        return this.$store.getters['UserManagement/getCarrentTenantUser'];
    }

    get socialTags() {
        return this.$store.getters['Tags/getSocialTags'];
    }

    get educationalTags() {
        return this.$store.getters['Tags/getEducationalTags'];
    }

    get professionTags() {
        return this.$store.getters['Tags/getProfessionTags'];
    }

    get currentTenantSocialTags() {
        return this.$store.getters['UserManagement/getCarrentTenantUser'].socialClubTags;
    }

    get currentTenantEducationalTags() {
        return this.$store.getters['UserManagement/getCarrentTenantUser'].educationTags;
    }

    get filteredEducationalTags() {
        const filteredEducationalTags = this.educationalTags;
        const existingTagIds = this.currentTenantEducationalTags.map((t: any) => t.id);
        return filteredEducationalTags.filter((tag: any) => {
            return !existingTagIds.includes(tag.id) && tag.name.toLowerCase().includes(this.educationalTagsSearch.toLowerCase());
        });
    }

    get filteredSocialTags() {
        const filteredSocialTags = this.socialTags;
        const existingTagIds = this.currentTenantSocialTags.map((t: any) => t.id);
        return filteredSocialTags.filter((tag: any) => {
            return !existingTagIds.includes(tag.id) && tag.name.toLowerCase().includes(this.socialTagsSearch.toLowerCase());
        });
    }

    public addNewSocialClubTag() {
        if (this.socialTagsSearch.length < 2) {
            return;
        }

        let existingTag: any = null;

        const filteredSocialTags = this.socialTags;
        const existingTagIds = this.currentTenantSocialTags.map((t: any) => t.id);

        filteredSocialTags.filter((tag: any) => {
            if (tag.name.toLowerCase() === this.socialTagsSearch.toLowerCase()) {
                existingTag = tag;
            }
        });

        if (existingTag) {
            if (existingTagIds.includes(existingTag.id)) {
                this.notify('tag_already_exists_in_interests_list', 'warning');
            } else {
                this.addSocialClubTag(existingTag);
                this.notify('tag_has_been_added_please_submit_form_to_save_changes', 'warning');
            }
        } else {
            this.$store.dispatch(Actions.CREATE_SOCIAL_TAG, {id: this.currentTenant.id, name: this.socialTagsSearch});
        }
        this.socialTagsSearch = '';
    }

    public addNewEducationalTag() {
        if (this.educationalTagsSearch.length < 2) {
            return;
        }
        let existingTag: any = null;
        const filteredEducationalTags = this.educationalTags;
        const existingTagIds = this.currentTenantEducationalTags.map((t: any) => t.id);

        filteredEducationalTags.filter((tag: any) => {
            if (tag.name.toLowerCase() === this.educationalTagsSearch.toLowerCase()) {
                existingTag = tag;
            }
        });

        if (existingTag) {
            if (existingTagIds.includes(existingTag.id)) {
                this.notify('tag_already_exists_in_educational_list', 'warning');
            } else {
                this.addEducationalTag(existingTag);
                this.notify('tag_has_been_added_please_submit_form_to_save_changes', 'warning');
            }
        } else {
            this.$store.dispatch(Actions.CREATE_EDUCATIONAL_TAG, {id: this.currentTenant.id, name: this.educationalTagsSearch});
        }
        this.educationalTagsSearch = '';
    }

    public closeDropDown() {
        this.socialTagsSearch = '';
        this.educationalTagsSearch = '';
    }

    public removeEducationalTag(tag: any) {
        this.$store.commit(Mutations.REMOVE_EDUCATIONAL_TAG, tag.id);
    }

    public removeSocialClubTag(tag: any) {
        this.$store.commit(Mutations.REMOVE_SOCIAL_TAG, tag.id);
    }

    public addEducationalTag(tag: any) {
        this.closeDropDown();
        this.$store.commit(Mutations.ADD_EDUCATIONAL_TAG, tag);
    }

    public addSocialClubTag(tag: any) {
        this.closeDropDown();
        this.$store.commit(Mutations.ADD_SOCIAL_TAG, tag);
    }

    public saveProfilingChanges() {
        const tenanat = this.currentTenant;
        const data = {
            id: tenanat.id,
            profession: tenanat.profession,
            education: tenanat.educationTags.map((t: any) => t.id),
            socialClubTagIds: tenanat.socialClubTags.map((t: any) => t.id),
        };

        this.$store.dispatch(Actions.SAVE_PROFILING_CHANGES, data);
    }

    public created() {
        window.addEventListener('click', this.closeDropDown);
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_TAGS, {type: 'demographic'});
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
    }
}
